import React,{ createContext, useState,useEffect } from "react";
import { LayoutProps, User } from "../common.interface";


export const UserContext = createContext<any>('userContext');

const UserContextProvider=({children}:LayoutProps)=>{
    // const [activePage, setActivePage] = useState("/");
    // let path = window.location.pathname;

    const [user,setUser]=useState<User|null>(() => {
        const storedUser = localStorage.getItem("userProfile");
        return storedUser ? JSON.parse(storedUser) : null;
      })

    useEffect(()=>{
        getLocalUser();
        // setActivePage(path);
       },[])

    async function setLocalUser(userResponse:User){
        // console.log('=========data to set local storage===')
        // console.log(userResponse)
        localStorage.setItem("userProfile",JSON.stringify(userResponse))
        setUser(userResponse)
        // TODO:find a way to make local storage setitem happen in real time
    }
    function getLocalUser(){
        const storedUser=localStorage.getItem('userProfile')
        if(storedUser){
            setUser(JSON.parse(storedUser))
            // console.log('==========local user============')
            // console.log([item])
            return storedUser
        }
        return null
    }
    function removeLocalUser(){
        localStorage.removeItem('userProfile')
        setUser(null);
    }

    return (
        <UserContext.Provider value={{setLocalUser,removeLocalUser,getLocalUser,setUser,user}}>
            {children}
        </UserContext.Provider>
    );
};

export default UserContextProvider;